export default __webpack_public_path__ + "static/media/sounds/tqvm_practice_screen_active_state_Alyx.mp3";